<template>
  <img
    class="avatar"
    :src="IMGURL"
    style="width: 1.2rem; height: 1.2rem; border-raidus: 0.12rem"
  />
</template>
<script>
import defaultAvatar from '@/assets/images/ys-avatar.png'
import { isNullOrEmpty } from '@/utils'
export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      IMGURL: isNullOrEmpty(this.url)
        ? defaultAvatar
        : this.url.replace('http:', '')
    }
  }
}
</script>
